import React from "react";
import { default as WTableSortLabel } from "@mui/material/TableSortLabel";

function TableSortLabel(props) {
  return <WTableSortLabel {...props} />;
}

export default TableSortLabel;
